import { SelectedAssets } from './questions';

export type TaskAssignerSortBy = 'id' | 'created_at' | 'mobile_user' | 'start_time';

/** Location filter: ids and type always cleared/set together. */
export type TaskAssignerLocationFilterValue =
  | { ids: number[]; type: 'nestable_locations' | 'locations' }
  | null;

export enum TASK_ASSIGNER_FILTERS_NAME {
  DATE_RANGE = 'dateRange',
  LOCATION = 'location',
  LOCATION_TYPE = 'locationType',
  FORM = 'form',
  STATUS = 'status',
  USER = 'user',
  GROUP = 'group',
  TASK_ID = 'taskId',
  ASSET = 'asset',
  ORIGIN = 'origin',
}

/** Radio-style filter for task origin: individual, planning, or group. */
export type TaskAssignerOriginFilterValue = 'individual' | 'planning' | 'group' | null;

export interface TaskAssignerFilters {
  [TASK_ASSIGNER_FILTERS_NAME.DATE_RANGE]: { from: Date; to: Date } | null;
  [TASK_ASSIGNER_FILTERS_NAME.LOCATION]: number[] | null;
  [TASK_ASSIGNER_FILTERS_NAME.LOCATION_TYPE]: 'nestable_locations' | 'locations' | null;
  [TASK_ASSIGNER_FILTERS_NAME.FORM]: number[] | null;
  [TASK_ASSIGNER_FILTERS_NAME.STATUS]: string[] | null;
  [TASK_ASSIGNER_FILTERS_NAME.USER]: number[] | null;
  [TASK_ASSIGNER_FILTERS_NAME.GROUP]: number[] | null;
  [TASK_ASSIGNER_FILTERS_NAME.TASK_ID]: string | null;
  [TASK_ASSIGNER_FILTERS_NAME.ASSET]: SelectedAssets | null;
  [TASK_ASSIGNER_FILTERS_NAME.ORIGIN]: TaskAssignerOriginFilterValue;
}
